"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetParentIconStyle = exports.DescriptionDialogBodyStyle = exports.InheritedRow = exports.InheritedDetailsValue = exports.InheritedDetailsLabel = exports.DescriptionText = exports.DescriptionLabel = exports.ColumnDescriptionInheritedTableRow = exports.ColumnDescriptionInheritedColumnRow = exports.ColumnDescriptionCell = exports.ColumnDescriptionFieldName = exports.ColumnDescriptionPane = exports.ColumnDescriptionWrapper = exports.dialogWidth = void 0;
var widgets_1 = require("@tableau/widgets");
var LayoutComponents_1 = require("../style/LayoutComponents");
var VizPortalStyles_1 = require("../style/VizPortalStyles");
var BrowserDetection_1 = require("../utils/BrowserDetection");
exports.dialogWidth = 300;
exports.ColumnDescriptionWrapper = LayoutComponents_1.divWithStyle('ColumnDescriptionWrapper', __assign({ backgroundColor: widgets_1.TabStyles.Colors.White, borderColor: widgets_1.TabStyles.Colors.L5, borderRadius: widgets_1.TabStyles.Sizing.BorderRadius, borderStyle: 'solid', borderWidth: widgets_1.TabStyles.Sizing.BorderWidth, boxShadow: widgets_1.TabStyles.Shadow.Elevated, cursor: 'default', display: 'flex', flexDirection: 'column' }, (BrowserDetection_1.isIE && { overflowY: 'auto' })));
exports.ColumnDescriptionPane = LayoutComponents_1.divWithStyle('ColumnDescriptionPane', __assign(__assign({}, VizPortalStyles_1.vizPortalFontStyle), { fontSize: widgets_1.TabStyles.Typography.Sizing.Default, margin: '16px', maxWidth: '300px' }));
exports.ColumnDescriptionFieldName = LayoutComponents_1.divWithStyle('ColumnDescriptionFieldName', {
    fontSize: widgets_1.TabStyles.Typography.Sizing.XLarge,
    margin: '8px 0',
});
exports.ColumnDescriptionCell = LayoutComponents_1.divWithStyle('ColumnDescriptionCell', {
    padding: '16px 0 0',
});
exports.ColumnDescriptionInheritedColumnRow = LayoutComponents_1.divWithStyle('ColumnDescriptionInheritedRow', { display: 'table' });
exports.ColumnDescriptionInheritedTableRow = LayoutComponents_1.divWithStyle('ColumnDescriptionInheritedRow', { display: 'table', paddingTop: '8px' });
exports.DescriptionLabel = LayoutComponents_1.divWithStyle('DescriptionLabel', {
    fontSize: widgets_1.TabStyles.Typography.Sizing.Default,
    fontWeight: 'bold',
});
exports.DescriptionText = LayoutComponents_1.divWithStyle('DescriptionText', {
    fontSize: widgets_1.TabStyles.Typography.Sizing.Default,
    marginTop: '8px',
});
exports.InheritedDetailsLabel = LayoutComponents_1.divWithStyle('InheritedDetailsLabel', {
    display: 'table-cell',
    color: widgets_1.TabStyles.Typography.Color.Secondary,
    paddingRight: widgets_1.TabStyles.Spacing.SmallSpace,
    textAlign: 'right',
    whiteSpace: 'nowrap',
    verticalAlign: 'top',
});
exports.InheritedDetailsValue = LayoutComponents_1.divWithStyle('InheritedDetailsValue', {
    maxWidth: '300px',
    maxHeight: '150px',
    overflow: 'auto',
});
exports.InheritedRow = LayoutComponents_1.divWithStyle('InheritedRow', {
    display: 'table-row',
});
exports.DescriptionDialogBodyStyle = {
    padding: '0px',
};
exports.AssetParentIconStyle = {
    padding: '0 3px',
    verticalAlign: 'top',
};
//# sourceMappingURL=ColumnDescriptionDialogStyles.js.map